import React from 'react';
import { FragmentsInterface } from '../components/fragments/FragmentsInterface';

const Legatia = () => {
  return (
    <div className="h-full">
      <FragmentsInterface />
    </div>
  );
};

export default Legatia;